<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :aria-labelledby="id"
    role="img"
  >
    <title :id="id">{{ altTextIcon }}</title>
    <circle cx="50%" cy="50%" r="9" :fill="questionMarkColor" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.2749 7.92633C11.7861 7.84249 11.2834 7.93434 10.8558 8.18562C10.4283 8.4369 10.1034 8.8314 9.93884 9.29923C9.7739 9.76812 9.26008 10.0145 8.79118 9.84957C8.32229 9.68463 8.0759 9.1708 8.24084 8.70191C8.54648 7.83308 9.14974 7.10045 9.94378 6.63378C10.7378 6.16712 11.6714 5.99653 12.5792 6.15224C13.4869 6.30794 14.3103 6.77989 14.9034 7.4845C15.4965 8.18894 15.8211 9.08049 15.8198 10.0013C15.8195 11.4787 14.7233 12.4633 13.9191 12.9994C13.4895 13.2858 13.0663 13.4967 12.7541 13.6355C12.5967 13.7055 12.4643 13.7585 12.3691 13.7947C12.3215 13.8129 12.2829 13.8269 12.255 13.8368L12.2213 13.8487L12.2107 13.8523L12.207 13.8535L12.2056 13.854L12.205 13.8542C12.2047 13.8543 12.2045 13.8544 11.9323 13.0379L12.2044 13.8544C11.7329 14.0116 11.2232 13.7567 11.066 13.2852C10.909 12.8142 11.1631 12.3052 11.6335 12.1473L11.6343 12.1471L11.6344 12.147L11.6348 12.1469L11.6356 12.1466L11.652 12.1409C11.6681 12.1352 11.694 12.1257 11.7284 12.1127C11.7972 12.0864 11.8992 12.0457 12.0231 11.9906C12.2733 11.8794 12.6002 11.7153 12.9206 11.5017C13.6163 11.038 14.0198 10.5228 14.0198 10.0006V9.99923C14.0206 9.50329 13.8458 9.0231 13.5264 8.6437C13.207 8.2643 12.7637 8.01017 12.2749 7.92633ZM15.8198 10.0013V10.0006H14.9199L15.8198 10.0019L15.8198 10.0013ZM12 16.1C11.5029 16.1 11.1 16.5029 11.1 17C11.1 17.4971 11.5029 17.9 12 17.9H12.01C12.5071 17.9 12.91 17.4971 12.91 17C12.91 16.5029 12.5071 16.1 12.01 16.1H12Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "ResearchDirectionsQuestionMarkIcon",
  props: {
    id: { type: String, required: true },
    altTextIcon: {
      type: String,
      default: "Research Directions question mark icon",
    },
    questionMarkColor: { type: String, default: "none" },
  },
};
</script>
